module.exports = __webpack_public_path__ + "static/big-d1de0d14be1f49da6da8c8f8daf4c445.png";